import React from 'react';
import { motion } from 'framer-motion';
import './LoadingScreen.css';

const letters = ['U', 'N', 'S', 'C', 'R', 'A', 'M', 'B', 'L', 'E'];

const LoadingScreen = ({ message = "Unscrambling your thoughts..." }) => {
  return (
    <motion.div
      className="loading-screen"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
    >
      <div className="loading-content">
        <div className="loading-blocks">
          {letters.map((letter, index) => (
            <motion.div
              key={index}
              className="loading-block"
              animate={{
                rotateY: [0, 360],
              }}
              transition={{
                duration: 0.6,
                delay: index * 0.15,
                repeat: Infinity,
                repeatDelay: letters.length * 0.15,
                ease: "easeInOut"
              }}
            >
              {letter}
            </motion.div>
          ))}
        </div>

        <motion.p
          className="loading-text"
          animate={{ opacity: [0.5, 1, 0.5] }}
          transition={{ duration: 2, repeat: Infinity }}
        >
          {message}
        </motion.p>
      </div>
    </motion.div>
  );
};

export default LoadingScreen;
